import { useState, useEffect } from 'react';
import { SOCIAL } from '@/config/assets';
import { Instagram, Youtube, ExternalLink } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Now', href: '#now-showing' },
  { label: 'Worlds', href: '#film-worlds' },
  { label: 'Echoes', href: '#echoes' },
  { label: 'Unseen', href: '#unseen' },
  { label: 'Tonight', href: '#tonight' },
  { label: 'Gifts', href: '#gifts' },
];

export default function FixedHeader({ visible }) {
  const [scrolled, setScrolled] = useState(false);

  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 80);
      setScrollProgress(Math.min(window.scrollY / 400, 1));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navColor = scrollProgress > 0.5 ? 'var(--gold)' : 'var(--ash)';

  return (
    <header
      data-testid="fixed-header"
      className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-500 ${scrolled ? 'bg-[#0A0A0A]/90 backdrop-blur-xl border-b border-white/[0.04]' : 'bg-transparent'}`}
      style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.8s ease, background 0.5s ease' }}
    >
      <div className="px-5 md:px-10 lg:px-20 h-14 md:h-16 flex items-center justify-between">
        {/* Logo + pulsing dot */}
        <div className="flex items-center gap-2">
          <a href="#" className="font-['Playfair_Display'] italic font-normal text-lg at-shimmer" style={{ paddingLeft: '0.15em', paddingRight: '0.05em', display: 'inline-block' }}>
            AT.
          </a>
          <span className="nav-dot" />
        </div>

        {/* Nav */}
        <nav className="hidden md:flex items-center gap-7">
          {NAV_LINKS.map(l => (
            <a key={l.label} href={l.href} className="font-['Cormorant_Garamond'] text-sm tracking-[0.2em] uppercase transition-colors duration-500 hover:text-[var(--gold)]" style={{ color: navColor }}>
              {l.label}
            </a>
          ))}
          <a href="#inside" className="font-['Cormorant_Garamond'] text-sm tracking-[0.2em] uppercase px-4 py-1.5 rounded-full transition-all duration-300 hover:bg-[rgba(201,168,76,0.1)]" style={{ color: 'var(--gold)', border: '1px solid rgba(201,168,76,0.3)' }}>
            Inside
          </a>
        </nav>

        {/* Social */}
        <div className="flex items-center gap-4">
          <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" data-testid="nav-instagram" className="transition-colors duration-300" style={{ color: 'var(--ash)' }}><Instagram className="w-[14px] h-[14px]" strokeWidth={1.5} /></a>
          <a href={SOCIAL.youtube} target="_blank" rel="noopener noreferrer" data-testid="nav-youtube" className="transition-colors duration-300" style={{ color: 'var(--ash)' }}><Youtube className="w-[14px] h-[14px]" strokeWidth={1.5} /></a>
          <a href={SOCIAL.imdb} target="_blank" rel="noopener noreferrer" data-testid="nav-imdb" className="transition-colors duration-300" style={{ color: 'var(--ash)' }}><ExternalLink className="w-[14px] h-[14px]" strokeWidth={1.5} /></a>
        </div>
      </div>
    </header>
  );
}
